import React from 'react';
import EnterpriseLogo from '../../images/spectrum_business_logo.svg';

const Logo = () => <img src={EnterpriseLogo} alt="Spectrum Enterprise logo" />;

export default Logo;
